import * as z from "zod/v4";

const WorkOrderPickLineRowSchema_ = z.object({
  id: z.string(),
  productId: z.string().nullish(),
  productSku: z.string().nullish(),
  productName: z.string().nullish(),
  productImageUrl: z.string().nullish(),
  status: z.string(),
  quantityRequired: z.number(),
  quantityCommitted: z.number(),
  quantityPicked: z.number(),
  sourceStorageLocationName: z.string().nullish(),
  sourceQuantityAvailable: z.number().nullish(),
});
export const WorkOrderPickLineRowSchema: z.ZodType<WorkOrderPickLineRow> =
  WorkOrderPickLineRowSchema_;
export interface WorkOrderPickLineRow
  extends z.infer<typeof WorkOrderPickLineRowSchema_> {}

const CustomAttributeSchema_ = z.object({ key: z.string(), value: z.string() });

const WorkOrderTableRowSchema_ = z.object({
  id: z.string(),
  accountId: z.string(),
  locationId: z.string(),
  flowId: z.string(),
  flowVersionId: z.string().nullish(),
  fulfillmentGroupId: z.string().nullish(),
  externalOrderId: z.string().nullish(),
  externalOrderName: z.string().nullish(),
  lineItemId: z.string().nullish(),
  triggerKind: z.string(),
  status: z.string(),
  currentStepId: z.string().nullish(),
  currentStepTitle: z.string().nullish(),
  currentStepStartedAt: z.coerce.date().nullish(),
  currentStepUserId: z.string().nullish(),
  quantity: z.coerce.number(),
  orderCreatedAt: z.coerce.date().nullish(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  completedAt: z.coerce.date().nullish(),
  cancelledAt: z.coerce.date().nullish(),
  pickLines: z.array(WorkOrderPickLineRowSchema),
  bomId: z.string().nullish(),
  bomName: z.string().nullish(),
  outputProductId: z.string().nullish(),
  outputProductName: z.string().nullish(),
  outputProductSku: z.string().nullish(),
  outputProductImageUrl: z.string().nullish(),
  toteNames: z.array(z.string()).optional(),
  lineItemCustomAttributes: z.array(CustomAttributeSchema_).optional(),
});
export const WorkOrderTableRowSchema: z.ZodType<WorkOrderTableRow> =
  WorkOrderTableRowSchema_;
export interface WorkOrderTableRow
  extends z.infer<typeof WorkOrderTableRowSchema_> {}
